export default __webpack_public_path__ + "images/02961697c436d5a3dd055db8159678f5-spirituality.jpg";